/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'snapshot': {
    width: 16,
    height: 16,
    viewBox: '0 0 325 325',
    data: '<path pid="0" d="M0 266.347v-58.56h8.467v109.007h109.008v8.114H0v-58.56zm207.786 54.504v-4.057h109.008V207.786h8.114v117.122H207.786v-4.057zM101.6 201.436v-21.872h3.175v40.922h40.922v2.822H101.6v-21.872zm77.964 20.461v-1.41h40.922v-40.923h2.822v43.744h-43.744v-1.41zM101.6 123.65V101.6h44.097v3.175h-40.922v40.922H101.6V123.65zm118.886 1.587v-20.461h-40.922V101.6h43.744v44.097h-2.822v-20.46zM0 58.737V0h117.475v8.467H8.467v109.008H0V58.737zm316.794 4.234V8.467H207.786V0h117.122v117.475h-8.114V62.971z"/>'
  }
})
